import { ContentCard, Divider, TextCallout } from '@indigo-ag/component-module';
import i18next from 'i18next';
import React from 'react';
import { text } from 'shared';
import styled from 'styled-components';

interface Props {
  comments?: string;
  positivePoints?: string;
  attentionPoints?: string;
}

const CommentContainer = styled.div`
  margin-top: 16px;
`;

const CommentBody = styled.p`
  width: 90%;
  margin: 16px 0 0 16px;
  font-size: 1rem;
  line-height: 1.75rem;
  color: #303c41;
  min-height: 2rem;
`;

export const Comments = ({ comments, positivePoints, attentionPoints }: Props) => {
  return (
    <ContentCard titleText={text.toTitleCase(i18next.t('comments'))}>
      {!comments && !positivePoints && !attentionPoints ? (
        <>{i18next.t('noResultsFound')}</>
      ) : (
        <>
          <CommentContainer>
            <TextCallout variant="success" label={i18next.t('positivePoints')} />
            <Divider />
            <CommentBody>{positivePoints}</CommentBody>
          </CommentContainer>
          <CommentContainer>
            <TextCallout variant="error" label={i18next.t('attentionPoints')} />
            <Divider />
            <CommentBody>{attentionPoints}</CommentBody>
          </CommentContainer>
          <CommentContainer>
            <TextCallout label={i18next.t('otherComments')} />
            <Divider />
            <CommentBody>{comments}</CommentBody>
          </CommentContainer>
        </>
      )}
    </ContentCard>
  );
};
